import { logger } from "@rails/actioncable";
import { getJSON } from "jquery";
import "packs/autokana";
import e from "turbolinks";
const urlhead = (location.pathname.indexOf("recurrent_database") !== -1) ? "/recurrent_database" : "";
const gitan_department = '聴覚部'
const gidai_department = '産業技術学部'
const gmaster_department = '技術科学研究科'
// HTML上では大文字ではなく、小文字になるみたい。
const other_name = "other"
const gitan_name = "tct"
const gidai_name = "ntut"
const gmaster_name = "gs"

// -------------関数（メソッド）記述--------------

/*
//  ◎：技大に関する表示データのリセット
function reset_gidai() {
  // OBOG情報欄
  $('#user_graduation_year').val('');  // 卒業年の値を空にする
  $('#user_final_education').val('');  // 最終学歴の値を空にする
  $('#user_school').val('');  // 学校名の値を空にする
  $('#user_department').val('');  // 出身学部の値を空にする
  $('#user_course').val('');  // 出身学科の値を空にする
  //$("#department_wrapper").show();  // OBOG情報欄の出身学部の入力項目を表示させる

  //  以下を実行すると、viewフォルダ内の「graduation_subjects.js.erb」に
  //  記載されているコードの動きに合わせて、以下が実行されるので、頭に入れておく。
  //  ・HTMLタグ【department_course_index（卒業学科）】から格納済の値が消去される。
  //  以下の関数は、viewフォルダ内の「graduation_subjects.js.erb」のコードも含めて
  //  一緒に動きを追わないと、意図を理解しづらいので気を付けること。
  $.ajax({
    url: urlhead + "/users/graduation_subjects",
    type: "GET",
    data: { graduation_frame_id: '' }
  }).done(function (data, textStatus, jaXHR) {
      var message = data.message;
      //console.log(message);
  }).fail(function() {
      //console.log("エラーが発生しました。");
  });

  // Q02-1-a「卒業年」「卒業学科」の値が変わった時のイベントをオフにする。
  $('select[name="user[g_graduation_year]"]').off("change");
  $('select[name="department_course"]').off("change"); 
}
*/

// ◎：技大関連情報欄の細かい表示設定
function show_gidai_register_customize(flg=true) {
  if(flg){
    if($('#user_is_tsukutech_' + gitan_name).prop('checked')){
      $('#a_gitan').show(); $('#pa_gitan').show();
    }
    else{ 
      $('#a_gitan').hide(); $('#pa_gitan').hide();
    }
    if($('#user_is_tsukutech_' + gidai_name).prop('checked')){
      $('#b_gidai').show(); $('#pb_gidai').show();
    }
    else{ 
      $('#b_gidai').hide(); $('#pb_gidai').hide();
    }
    if($('#user_is_tsukutech_' + gmaster_name).prop('checked')){
      $('#c_gmaster').show(); $('#pc_gmaster').show();
    }
    else{ 
      $('#c_gmaster').hide(); $('#pc_gmaster').hide();
    }

    $('.gidai-register').fadeIn('slow');
  }
  else{
    $('.gidai-register').hide();
  }
}

// ◎：「聴覚障害者のためのピアサポーター」情報欄の細かい表示設定
function show_obog_register_customize(flg=true) {
  if(flg){
    if(!$('#user_is_tsukutech_' + other_name).prop('checked')){
      if($('input:radio[name="user[is_other_final]"]:checked').val() != 'false'){
        $('.show_other').show();
      }
      else{
        $('.show_other').hide();
      }  
    }
    else{
      $('.show_other').show();
    }
    
    $('.obog-register').show();
  }
  else{
    $('.obog-register').hide();
  }
}

// ◎：技大関連情報欄の応答/非応答切替
function disabled_gidai_register(flg=true) {
  // 以下の関数内における、コメントアウト行は隠しフィールドへの設定

  if($('#user_is_tsukutech_' + gitan_name).prop('checked')){
    $('#user_c_admission_year').prop('disabled', flg);
    $('#user_c_graduation_year').prop('disabled', flg);
    $('#user_c_department_course').prop('disabled', flg);
    //$('#user_c_department').prop('disabled', flg);
    //$('#user_c_course').prop('disabled', flg);
  }else{
    $('#user_c_admission_year').prop('disabled', true);
    $('#user_c_graduation_year').prop('disabled', true);
    $('#user_c_department_course').prop('disabled', true);
    //$('#user_c_department').prop('disabled', true);
    //$('#user_c_course').prop('disabled', true);
  }

  if($('#user_is_tsukutech_' + gidai_name).prop('checked')){
    $('#user_u_graduation_frame').prop('disabled', flg);
    $('#user_u_admission_year').prop('disabled', flg);
    $('#user_u_graduation_year').prop('disabled', flg);
    $('#user_u_department_course').prop('disabled', flg);
    //$('#user_u_department').prop('disabled', flg);
    //$('#user_u_course').prop('disabled', flg);
  }else{
    $('#user_u_graduation_frame').prop('disabled', true);
    $('#user_u_admission_year').prop('disabled', true);
    $('#user_u_graduation_year').prop('disabled', true);
    $('#user_u_department_course').prop('disabled', true);
    //$('#user_u_department').prop('disabled', true);
    //$('#user_u_course').prop('disabled', true);
  }

  if($('#user_is_tsukutech_' + gmaster_name).prop('checked')){
    $('#user_m_admission_year').prop('disabled', flg);
    $('#user_m_graduation_year').prop('disabled', flg);
    $('#user_m_department_course').prop('disabled', flg);
    //$('#user_m_department').prop('disabled', flg);
    //$('#user_m_course').prop('disabled', flg);
  }
  else{
    $('#user_m_admission_year').prop('disabled', true);
    $('#user_m_graduation_year').prop('disabled', true);
    $('#user_m_department_course').prop('disabled', true);
    //$('#user_m_department').prop('disabled', true);
    //$('#user_m_course').prop('disabled', true);
  }
}

// ◎：OBOG情報欄の応答/非応答切替
function disabled_obog_register(flg=true) {
  $('#user_name').prop('disabled', flg);
  $('#user_kana').prop('disabled', flg);

  $('#user_maiden_name').prop('disabled', flg);
  $('#user_maiden_kana').prop('disabled', flg);

  $('#user_graduation_year').prop('disabled', flg);
  $('#user_final_education').prop('disabled', flg);
  $('#user_school').prop('disabled', flg);
  $('#user_department').prop('disabled', flg);
  $('#user_course').prop('disabled', flg);

  //$('#user_work_status').prop('disabled', flg);
  $('#user_work_status_就労中である').prop('disabled', flg);// マジックナンバーに注意
  $('#user_work_status_就労中ではない').prop('disabled', flg);// マジックナンバーに注意
  
  $('#user_company').prop('disabled', flg);
  $('#user_work_place').prop('disabled', flg);
  $('#user_assienment').prop('disabled', flg);
  $('#user_work_industry').prop('disabled', flg);
  $('#user_other_industry').prop('disabled', flg);
  $('#user_work_job').prop('disabled', flg);
  $('#user_other_job').prop('disabled', flg);
  $('#user_work_description').prop('disabled', flg);

  $('input:checkbox[name="user[communication][]"]').prop('disabled', flg);
  $('#user_tel').prop('disabled', flg);
  $('#user_fax').prop('disabled', flg);
  $('#user_comment').prop('disabled', flg);
  $('#user_query').prop('disabled', flg);
}

// ◎：ログイン情報欄の応答/非応答切替
function disabled_login_register(flg=true) {
  $('#user_email').prop('disabled', flg);
  $('#user_password').prop('disabled', flg);
  $('#user_password_confirmation').prop('disabled',flg);
}

// ◎：必須を付ける、外すを実施する関数
function check_add_or_remove_req(flag, target){
  if( flag ){
    //  必須項目から外す。
    $('#' + target + '_wrapper td:first').removeClass('required');
    $('#' + target + '_wrapper').find('#user_' + target).removeClass('req');
    $('#' + target + '_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする
  } else {
    //  必須項目とする。
    $('#' + target + '_wrapper td:first').addClass('required');
    $('#' + target + '_wrapper').find('#user_' + target).addClass('req');
  }
}

// ◎：OBOG情報欄の一部の入力項目を（必須⇔任意）に変更
function change_faculty_optional() {

  //　関数定義
  const isIncludes = (arr, target) => arr.some(word => target.includes(word)); //  arr配列の各要素（文字列word）の中で、targetの文字列に含まれているものが存在するのか
  //const isMatchs = (arr, target) => arr.some(word => target.match(word)); //  arr配列の各要素（文字列word）の中で、targetの文字列と完全一致するwordがあるかどうか

  //  定数定義
  const searchWord1 = ['大学院','大学'];
  const searchWord2 = [gidai_name, gitan_name];
  const ws_result = ($('input:radio[name="user[work_status]"]:checked').val() == '就労中である'); // 0はマジックナンバーになってしまうけど・・・。
  //const searchWord3 = ['就労中'];
/*
  if( !isIncludes(searchWord1, $('#user_final_education option:selected').text())  //  "大学院"または"大学"のどちらかが、最終学歴に含まれていないこと
   && !isIncludes(searchWord2, $('#user_school').val()) // "筑波技術大学"または"筑波技術短期大学"が出身学校に含まれていないこと
   && $('input:radio[name="user[is_gidai]"]:checked').val() == 'false'){ // 技大（技短・技大大学院）卒かどうかに「いいえ」と答えたこと
    //  上記3点全て満たしたとき（true）
*/

  check_add_or_remove_req(!isIncludes(searchWord1, $('#user_final_education option:selected').text()), 'department');
  check_add_or_remove_req(!isIncludes(searchWord2, $('#user_school').val()), 'course');
  //check_add_or_remove_req(!isIncludes(searchWord3, $('#user_work_status option:selected').val()), 'company');
  //check_add_or_remove_req(!isIncludes(searchWord3, $('#user_work_status option:selected').val()), 'work_place');
  //check_add_or_remove_req(!isIncludes(searchWord3, $('#user_work_status option:selected').val()), 'assienment');
  check_add_or_remove_req(!ws_result, 'company');
  check_add_or_remove_req(!ws_result, 'work_place');
  check_add_or_remove_req(!ws_result, 'assienment');

  /*
  //  "大学院"または"大学"のどちらかが、最終学歴に含まれていないとき
  if( !isIncludes(searchWord1, $('#user_final_education option:selected').text()) ){ 
    //  出身学部への入力項目は必須項目から外す。
    $('#department_wrapper td:first').removeClass('required');
    $('#department_wrapper').find('#user_department').removeClass('req');
    $('#department_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする
    //$('#department_wrapper').find('#user_department').removeAttr('required');
  } else {
    //  出身学部への入力項目は必須項目とする。
    $('#department_wrapper td:first').addClass('required');
    $('#department_wrapper').find('#user_department').addClass('req');
    //$('#department_wrapper').find('#user_department').attr('required','required');
  }

  //if(isMatchs(searchWord2, $('#user_school').val()) // "筑波技術大学"または"筑波技術短期大学"が出身学校名と一致すること
  //|| $('input:radio[name="user[is_gidai]"]:checked').val() == 'true') { // 技大（技短・技大大学院）卒かどうかに「はい」と答えたこと
    //  上記2点のうちいずれかを満たしたとき

  if( !isIncludes(searchWord2, $('#user_school').val()) ){
    //  出身学科への入力項目は必須項目から外す。
    $('#course_wrapper td:first').removeClass('required');
    $('#course_wrapper').find('#user_course').removeClass('req');
    $('#course_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする
    //$('#course_wrapper').find('#user_course').removeAttr('required');
  } else {
    //  出身学科への入力項目は必須項目とする。
    $('#course_wrapper td:first').addClass('required');
    $('#course_wrapper').find('#user_course').addClass('req');
    //$('#course_wrapper').find('#user_course').attr('required','required');
  }

  if( !isIncludes(searchWord3, $('#user_work_status option:selected').val()) ){
    //  会社名、勤務地、配属先への入力項目は必須項目から外す。
    $('#company_wrapper td:first').removeClass('required');
    $('#company_wrapper').find('#user_company').removeClass('req');
    $('#company_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする

    $('#work_place_wrapper td:first').removeClass('required');
    $('#work_place_wrapper').find('#user_work_place').removeClass('req');
    $('#work_place_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする

    $('#assienment_wrapper td:first').removeClass('required');
    $('#assienment_wrapper').find('#user_assienment').removeClass('req');
    $('#assienment_wrapper').find('span.error_reauired').text(""); //　エラー文を空にする
  } else {
    //  現在「就労中」の場合に限り、会社名、勤務地、配属先への入力項目は必須項目とする。
    $('#company_wrapper td:first').addClass('required');
    $('#company_wrapper').find('#user_company').addClass('req');

    $('#work_place_wrapper td:first').addClass('required');
    $('#work_place_wrapper').find('#user_work_place').addClass('req');

    $('#assienment_wrapper td:first').addClass('required');
    $('#assienment_wrapper').find('#user_assienment').addClass('req');
  }
  */
}

// ◎：技大関連情報欄の一部の入力項目（卒業年）を（必須⇔任意）に変更
function gc_faculty_optional() {
  const nflg = ($('input:radio[name="user[is_other_final]"]:checked').val() == 'false'); // 最終学歴が技大関連であるときのみ
  const mflg = nflg && $('#user_is_tsukutech_' + gmaster_name).prop('checked');
  const uflg = nflg && !mflg && $('#user_is_tsukutech_' + gidai_name).prop('checked');
  const cflg = nflg && !mflg && !uflg && $('#user_is_tsukutech_' + gitan_name).prop('checked');

  check_add_or_remove_req(!cflg, 'c_graduation_year');
  check_add_or_remove_req(!uflg, 'u_graduation_year');
  check_add_or_remove_req(!mflg, 'm_graduation_year');
}

function change_visual_select_coops(flag,opa)
{
  //  どんな依頼でもOK!以外の各項目を非応答・半透明にしたり、応答可・非透明にする。
  $('input:checkbox[name="user[select_coops][]"]').each(function() {
    if($(this).val() != gon.all_coop_purpose){
      $(this).prop('disabled', flag);
      $('#coop_' + $(this).val()).fadeTo(0,opa);
    }
  });
}

// ◎：入力済の値によって、画面全体の各入力項目の初期状態を設定する。
function reg_form_show_toggle() {
  // 各種入力欄の表示初期設定
  show_gidai_register_customize(false);
  show_obog_register_customize(false);
  $('.login-register').hide();
  $('.actions').hide();
  $('.sorry').hide();

  //  各種入力欄の応答初期設定
  disabled_gidai_register(true);
  disabled_obog_register(true);
  disabled_login_register(true);

  // 画面再描画時は必ずリセット
  $('input:checkbox[id="user_agreement_agreement"]').prop('checked', false);
  $('#btn-send').prop("disabled", true);

  //  Q 01 メールマガジン登録
  if($('input:radio[name="user[is_mailmaga]"]:checked').val() == 'false'
  && $('input:radio[name="user[is_obog]"]:checked').val() == 'false') {
    // Q02で「いいえ」と回答した場合
    // 「聴覚障害者のためのピアサポーター」登録、メールマガジン登録どちらもその気がないということなので
    //  ごめんなさいを表示
    $('.q02').hide();
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();

    $('.sorry').fadeIn('slow');
  }
  else if(   (typeof $('input:radio[name="user[is_mailmaga]"]:checked').val()) !== "undefined"
          && (typeof $('input:radio[name="user[is_obog]"]:checked').val()) !== "undefined") {

  //if($('input:radio[name="user[is_mailmaga]"]:checked').val() == 'true'){
    // Q 01で「はい」と回答した場合、
    // ログイン情報欄への入力は応答可能とする。
    disabled_login_register(false);

    //  Q 01は回答済と考えられるため、
    //  Q 02を出現させておく。
    $('.q02').fadeIn('slow');
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();

    // Q 02 「聴覚障害者のためのピアサポーター」登録
    if($('input:radio[name="user[is_obog]"]:checked').val() == 'true') {
      
      // Q02で「はい」と回答した場合
      // OBOG情報欄への入力は応答可能とする。
      disabled_obog_register(false);

      // Q02-0の質問項目を出現させる
      $('.q02-0').fadeIn('slow');

      // Q02-0 協力目的の項目に回答済か
      if($('input:checkbox[name="user[select_coops][]"]:checked').length != 0)
      {
        // Q02-1の質問項目を出現させる
        $('.q02-1').fadeIn('slow');

        // どんな依頼でもOK!に対してチェックした場合、
        // 他の項目をdisableにするかそうでないかを判定する。
        let flag = ($('#user_select_coops_' + gon.all_coop_purpose).prop('checked') == true); // チェック済なら他を非応答とし、チェックしないなら応答可能とする。
        let opa = ($('#user_select_coops_' + gon.all_coop_purpose).prop('checked') == true) ? 0.5 : 1.0;

        //  どんな依頼でもOK!以外の各項目を非応答・半透明にしたり、応答可・非透明にする。
        change_visual_select_coops(flag,opa);
        q02_0_number = $('input:checkbox[name="user[select_coops][]"]:checked').length; // チェックした総数を記憶させる。

        // Q02-1 技大関係者の出身かどうか
        if($('input:checkbox[name="user[is_tsukutech][]"]:checked').length != 0){
 
          q02_1_number = $('input:checkbox[name="user[is_tsukutech][]"]:checked').length; // チェックした総数を記憶させる

          // 「聴覚障害者のためのピアサポーター」入力情報欄
          if(!$('#user_is_tsukutech_' + other_name).prop('checked'))
          {
            // "いずれも経験なし"以外にチェック（技大関係出身経験ありの場合）
            disabled_gidai_register(false); // 応答可能に切り替え
            $('.q02-2').fadeIn('slow');

            // Q02-2 最終学歴が技大関係以外かどうか
            if($('input:radio[name="user[is_other_final]"]:checked').val() == 'true'
            || $('input:radio[name="user[is_other_final]"]:checked').val() == 'false'){

              // 最後にOBOG情報欄、ログイン情報欄、入力確認欄を出現させる
              show_gidai_register_customize(true);
              show_obog_register_customize(true);
              $('.login-register').fadeIn('slow');
              $('.actions').fadeIn('slow');

              reset_add_query();
              
              //必要に応じて必須から任意に変更
              change_faculty_optional();
              gc_faculty_optional();

              // 最初に技大の卒業時期等についてsessionStorageからの復旧を実施
              restore_session_storage('user_u_graduation_frame');

              // 選択済の卒業時期に合わせて、卒業学科・専攻の選択肢を再設定
              set_graduation_subjects($('#user_u_graduation_frame').has('option:selected').val());

              // 技大の卒業学科・専攻に対して、選択肢を事前に設定できたので、あとは一括復旧
              restore_session_storage('user_c_admission_year');
              restore_session_storage('user_c_graduation_year');
              restore_session_storage('user_c_department_course');
              restore_session_storage('user_u_admission_year');
              restore_session_storage('user_u_graduation_year');
              restore_session_storage('user_u_department_course');
              restore_session_storage('user_m_admission_year');
              restore_session_storage('user_m_graduation_year');
              restore_session_storage('user_m_department_course');

              if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
                // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
                set_final_education_informations();
              }
              synchronize_hide_field(); // 隠しフィールドの同期
              // backup_session_storage(); // sessionStorageへのバックアップ不要のため、コメントアウト
            }
            // else {} //万が一、ここに処理が来るようなことがあれば、まだ入力が終わっていないということ？？？
          }
          else{
            // 最後にOBOG情報欄、ログイン情報欄、入力確認欄を出現させる
            show_obog_register_customize(true);
            $('.login-register').fadeIn('slow');
            $('.actions').fadeIn('slow');
            
            reset_add_query();

            //必要に応じて必須から任意に変更
            change_faculty_optional();
          }
        }
        // else{} //万が一、ここに処理が来るようなことがあれば、まだ入力が終わっていないということ？？？
      }
      // else{} //万が一、ここに処理が来るようなことがあれば、まだ入力が終わっていないということ？？？

    } else if($('input:radio[name="user[is_obog]"]:checked').val() == 'false') {
      // Q02で「いいえ」と回答した場合
      // ログイン情報欄、入力確認欄を出現させる
      $('.login-register').fadeIn('slow');
      $('.actions').fadeIn('slow');
    }
  }
  // else{} //万が一、ここに処理が来るようなことがあれば、まだ入力が終わっていないということ？？
}

//  ◎：確認ページ表示時に、OBOG情報欄、ログイン情報欄
//      それぞれで表示する必要があるか確認してから表示状態を設定
function cnf_show_toggle() {
  //  表示する必要があるかは、1つの項目のみチェックすれば問題なし
  const is_obog = $('input[name="user[name]"').is(':disabled'); // 氏名の入力が有効になっているか
  const is_login = $('input[name="user_email"]').is(':disabled'); // メールアドレスの入力が有効になっているか
  const is_gitan = $('select[name="user[c_admission_year]"').is(':disabled'); // 短大の入学年の入力が有効になっているか
  const is_gidai = $('select[name="user[u_admission_year]"').is(':disabled'); // 大学の入学年の入力が有効になっているか
  const is_gmaster = $('select[name="user[m_admission_year]"').is(':disabled'); // 大学院の入学年の入力が有効になっているか
  
  //gitan：
  if(is_gitan) {
    $('#cnf_gitan').hide();
  } else {
    $('#cnf_gitan').show('slow');
  }
  //gidai：
  if(is_gidai) {
    $('#cnf_gidai').hide();
  } else {
    $('#cnf_gidai').show('slow');
  }
  //gmaster：
  if(is_gmaster) {
    $('#cnf_gmaster').hide();
  } else {
    $('#cnf_gmaster').show('slow');
  }
  //obog：氏名の入力が有効になっていれば、OBOG情報欄を表示
  if(is_obog) {
    $('#cnf_obog').hide();
  } else {
    $('#cnf_obog').show('slow');
  }
  //login：メールアドレスの入力が有効になっていれば、ログイン情報欄を表示
  if(is_login){
    $('#cnf_login').hide();
  } else {
    $('#cnf_login').show('slow');
  }

  $('#cnf_personal_information').show('slow');
}

//  ◎：入力項目の値の確認ページの表示切替
function reg_cnf_change(toggle=true) {
  if (toggle) {
    //  入力ページ非表示
    $('#title').hide();
    $('div#reissue_error_explanation').hide();
    $('.objective_questioner').hide();
    $('.q01').hide();
    $('.q02').hide();
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();
    show_gidai_register_customize(false);
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();

    //  確認ページ表示
    $('.cnf_form').show();
    $('#cnf_msg').show();
    cnf_show_toggle();
    $('.actions02').show();

    //  送信ボタン有効
    //$('#btn-send').prop("disabled", false);
  } else {
    //  入力ページ表示
    $('#title').show();
    $('div#reissue_error_explanation').show();
    $('.objective_questioner').show();
    $('.q01').show();
    reg_form_show_toggle(); // 入力済の値に合わせて画面全体の各入力項目の状態を設定

    //  確認ページ非表示
    $('.cnf_form').hide();
    $('#cnf_msg').hide();
    $('.actions02').hide();

    //  送信ボタン無効
    $('#btn-send').prop("disabled", true);
    $('input:checkbox[id="user_agreement_agreement"]').prop("checked", false);
  }
}

// ◎：エラー用装飾のためのクラスを一斉に除去する。
// ※reg_errorはエラーが発生したときに、エラーのある項目の位置を特定するのに使用。
function remove_error_class() {
  //エラー用装飾のためのクラスリセット
  $('#user_c_admission_year').removeClass("reg_error");
  $('#user_c_graduation_year').removeClass("reg_error");
  $('#user_c_department_course').removeClass("reg_error");
  $('#user_u_admission_year').removeClass("reg_error");
  $('#user_u_graduation_year').removeClass("reg_error");
  $('#user_u_department_course').removeClass("reg_error");
  $('#user_m_admission_year').removeClass("reg_error");
  $('#user_m_graduation_year').removeClass("reg_error");
  $('#user_m_department_course').removeClass("reg_error");
  $('#user_u_graduation_frame').removeClass("reg_error");

  $('#user_name').removeClass("reg_error");
  $('#user_kana').removeClass("reg_error");

  $('#user_maiden_name').removeClass("reg_error");
  $('#user_maiden_kana').removeClass("reg_error");

  $('#user_graduation_year').removeClass("reg_error");
  $('#user_final_education').removeClass("reg_error");
  $('#user_school').removeClass("reg_error");
  $('#user_department').removeClass("reg_error");
  $('#user_course').removeClass("reg_error"); 

  //$('#user_work_status').removeClass("reg_error");
  $('#user_work_status_就労中である').removeClass("reg_error"); // マジックナンバーに注意

  $('#user_company').removeClass("reg_error");
  $('#user_work_place').removeClass("reg_error");
  $('#user_assienment').removeClass("reg_error");
  $('#user_work_industry').removeClass("reg_error");
  $('#user_other_industry').removeClass("reg_error");
  $('#user_work_job').removeClass("reg_error");
  $('#user_other_job').removeClass("reg_error");
  $('#user_work_description').removeClass("reg_error");

  $('#communication_check_box').removeClass("reg_error");
  $('#user_tel').removeClass("reg_error");
  $('#user_fax').removeClass("reg_error");
  $('#user_comment').removeClass("reg_error");
  $('#user_query').removeClass("reg_error");
  $('#user_email').removeClass("reg_error");
  $('#user_password').removeClass("reg_error");
  $('#user_password_confirmation').removeClass("reg_error");
}

// ◎：エラーメッセージを表示するためのタグを一斉に除去する。
function remove_input_error_msg() {
  $('span.error_reauired').empty();
  $('span.error_msg').empty();
  $('span#error_email').empty();
  $('span#pass_msg').empty();
  $('span.error_length').empty();
}

// ◎：各入力項目のエラーチェック
function reg_input_check() {
  var result = true;
  const is_obog = $('input[name="user[name]"').is(':disabled');
  const is_login = $('input[name="user_email"]').is(':disabled');
  const is_gitan = $('select[name="user[c_admission_year]"').is(':disabled'); // 短大の入学年の入力が有効になっているか
  const is_gidai = $('select[name="user[u_admission_year]"').is(':disabled'); // 大学の入学年の入力が有効になっているか
  const is_gmaster = $('select[name="user[m_admission_year]"').is(':disabled'); // 大学院の入学年の入力が有効になっているか
  const is_other_final = !($('input:radio[name="user[is_other_final]"]:checked').val() == 'false');

  //　エラー用装飾のクラスリセット
  //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
  //　（位置を特定できた場合、その位置まで自動スクロール可能）
  remove_error_class();

  //　入力エラー文をリセット
  //　エラー文：エラーが発生したときに表示されるメッセージ
  remove_input_error_msg();

  // 入力内容セット
  //const c_admission_year = $('#user_c_admission_year option:selected').val();
  //const u_admission_year = $('#user_u_admission_year option:selected').val();
  //const m_admission_year = $('#user_m_admission_year option:selected').val();
  const c_graduation_year = $('#user_c_graduation_year option:selected').val();
  const u_graduation_year = $('#user_u_graduation_year option:selected').val();
  const m_graduation_year = $('#user_m_graduation_year option:selected').val();
  const c_department_course = $('#user_c_department_course option:selected').val();
  const u_department_course = $('#user_u_department_course option:selected').val();
  const m_department_course = $('#user_m_department_course option:selected').val();
  const u_graduation_frame = $('#user_u_graduation_frame option:selected').val();

  const name = $('#user_name').val();
  const kana = $('#user_kana').val();
  //const maiden_name = $('#user_maiden_name').val();
  const maiden_kana = $('#user_maiden_kana').val();

  const graduation_year = $('#user_graduation_year option:selected').val();
  const final_education = $('#user_final_education option:selected').val();
  const school = $('#user_school').val();
  const department = $('#user_department').val();
  const course = $('#user_course').val();

  //const work_status = $('#user_work_status option:selected').val();
  const work_status = $('input:radio[name="user[work_status]"]:checked').val();
  const company = $('#user_company').val();
  const work_place = $('#user_work_place option:selected').val();
  const assienment = $('#user_assienment').val();
  //const work_industry = $('#user_work_industry').val();
  //const other_industry = $('#user_other_industry').val();
  //const work_job = $('#user_work_job').val();
  //const other_job = $('#user_other_job').val();
  //const work_description = $('#user_work_description').val();

  const communication_length = $('input:checkbox[name="user[communication][]"]:checked').length;
  const tel = $('#user_tel').val();
  const fax = $('#user_fax').val();
  //const comment = $('#user_comment').val();
  //const query = $('#user_query').val();
  const email = $('#user_email').val();
  const password = $('#user_password').val();
  const password_confirmation = $('#user_password_confirmation').val();
  const pass_minlength = $('em#password_length_msg').attr('minlength')

  //入力内容チェック
  // 技大関連情報欄
  if(!is_gitan) {
    if(c_department_course == "") {
      $('#user_c_department_course').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_c_department_course').addClass("reg_error");
      result = false;
    }

    if(c_graduation_year == "" && $('#user_c_graduation_year').hasClass('req')) {
      $('#user_c_graduation_year').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_c_graduation_year').addClass("reg_error");
      result = false;
    }
  }
  if(!is_gidai) {
    if(u_graduation_frame == "") {
      $('#user_u_graduation_frame').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_u_graduation_frame').addClass("reg_error");
      result = false;
    }

    if(u_department_course == "") {
      $('#user_u_department_course').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_u_department_course').addClass("reg_error");
      result = false;
    }

    if(u_graduation_year == "" && $('#user_u_graduation_year').hasClass('req')) {
      $('#user_u_graduation_year').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_u_graduation_year').addClass("reg_error");
      result = false;
    }
  }
  if(!is_gmaster) {
    if(m_department_course == "") {
      $('#user_m_department_course').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_m_department_course').addClass("reg_error");
      result = false;
    }

    if(m_graduation_year == "" && $('#user_m_graduation_year').hasClass('req')) {
      $('#user_m_graduation_year').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_m_graduation_year').addClass("reg_error");
      result = false;
    }
  }
  //「聴覚障害者のためのピアサポーター」情報登録欄
  if(!is_obog) {
    if(name == "") {
      $('#user_name').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_name').addClass("reg_error");
      result = false;
    }
    if(kana == "") {
      $('#user_kana').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_kana').addClass("reg_error");
      result = false;
    } else if(!kana.match(/^[ぁ-んー　]*$/)) {
      $('#user_kana').siblings('span.error_msg').text('全角ひらがなで入力してください').css('color','red');
      $('#user_kana').addClass("reg_error");
      result = false;
    }
    if(!maiden_kana.match(/^[ぁ-んー　]*$/)) {
      $('#user_maiden_kana').siblings('span.error_msg').text('全角ひらがなで入力してください').css('color','red');
      $('#user_maiden_kana').addClass("reg_error");
      result = false;
    }
    if(is_other_final)
    {
      if(graduation_year == "") {
        $('#user_graduation_year').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
        $('#user_graduation_year').addClass("reg_error");
        result = false;
      }
      if(final_education == "") {
        $('#user_final_education').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
        $('#user_final_education').addClass("reg_error");
        result = false;
      }
      if(school =="") {
        $('#user_school').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
        $('#user_school').addClass("reg_error");
        result = false;
      }
      if(department == "" && $('#user_department').hasClass('req')) {
        $('#user_department').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
        $('#user_department').addClass("reg_error");
        result = false;
      }
      if(course == "" && $('#user_course').hasClass('req')) {
        $('#user_course').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
        $('#user_course').addClass("reg_error");
        result = false;
      }  
    }

    //if(work_status == "") {
    if(typeof work_status === "undefined") {
      //$('#user_work_status').parents('.tbl_c').children('span.error_reauired').text("入力必須項目です").css('color', 'red');
      //$('#user_work_status').addClass("reg_error");
      $('#select_work_status').parents('.tbl_c').children('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#ex_work_status').addClass("reg_error");  // マジックナンバーに注意
      result = false;
    }
    if(company == "" && $('#user_company').hasClass('req')) {
      $('#user_company').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_company').addClass("reg_error");
      result = false;
    }
    if(work_place == "" && $('#user_work_place').hasClass('req')) {
      $('#user_work_place').parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
      $('#user_work_place').addClass("reg_error");
      result = false;
    }
    if(assienment == "" && $('#user_assienment').hasClass('req')) {
      $('#user_assienment').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_assienment').addClass("reg_error");
      result = false;
    }
    if(communication_length == 0) {
      $('input:checkbox[name="user[communication][]"]').parents('.tbl_c').children('span.error_reauired').text("いずれか1つ以上、選択してください").css('color', 'red');
      $('#communication_check_box').addClass("reg_error");
      result = false;
    }
    if(!tel.match(/^(\d{10,11})$/) && tel != "") {
      $('#user_tel').siblings('span.error_msg').text('正しい電話番号を入力してください').css('color','red');
      $('#user_tel').addClass("reg_error");
      result = false;
    } 
    if(!fax.match(/^(\d{10,11})$/) && fax != "") {
      $('#user_fax').siblings('span.error_msg').text('正しいFAX番号を入力してください').css('color','red');
      $('#user_fax').addClass("reg_error");
      result = false;
    }
  }
  
  //ログイン情報入力欄
  if(!is_login) {
    if(email == "") {
      $('#user_email').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_email').addClass("reg_error");
      result = false;
    } else if(!email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/)) {
      $('#user_email').siblings('span.error_reauired').text('正しい形式で入力してください。').css('color', 'red');
      $('#user_email').addClass("reg_error");
      result = false;
    }
    if(password.length == 0) {
      $('#user_password').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_password').addClass("reg_error");
      result = false;
    } else if(password.length < pass_minlength) {
      $('#user_password').siblings('span.error_length').html(pass_minlength+'文字以上で入力してください<br>').css('color','red');
      $('#user_password').addClass("reg_error");
      result = false;
    }
    if(password_confirmation.length == 0) {
      $('#user_password_confirmation').siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
      $('#user_password_confirmation').addClass("reg_error");
      result = false;
    } else if(password_confirmation.length <  pass_minlength) {
      $('#user_password_confirmation').siblings('span.error_length').html(pass_minlength+'文字以上で入力してください<br>').css('color','red');
      $('#user_password_confirmation').addClass("reg_error");
      result = false;
    } else if( password != password_confirmation) {
      $('#user_password_confirmation').siblings('span#pass_msg').html('パスワードが一致しません<br>').css('color', 'red');
      $('#user_password_confirmation').addClass("reg_error");
      result = false;
    }
  }
  return result;
}

// ◎（田中追加）：最終学歴に関する情報を一括設定
function set_final_education_informations() {

  // 最終学歴に用いる情報を決める
  let prefix = ''
  let school = '';
  let department_text = '';
  if($('#user_is_tsukutech_' + gmaster_name).prop('checked')){
    prefix = 'm'; school = '大学院'; department_text = gmaster_department;
  }
  else if($('#user_is_tsukutech_' + gidai_name).prop('checked')){ 
    prefix = 'u'; school = '技大'; department_text = gidai_department;
  }
  else if($('#user_is_tsukutech_' + gitan_name).prop('checked')){ 
    prefix = 'c'; school = '技短'; department_text = gitan_department; 
  }
  //else{
    // 何もしない
    // ここに到達しないはず。、もし到達することがあったとしたら、本関数を呼び間違えていないか確認。
  //}

  // 学歴が高い順に合わせて、最終学歴と学校名を自動設定
  set_school_and_final_education(school);

  // 最終学歴に用いる予定の情報を取得
  let gyear = $('#user_' + prefix + '_graduation_year option:selected').val();
  let dcourse = $('#user_' + prefix + '_department_course option:selected').text();

  // 最終学歴に関する卒業年、出身学部、出身学科も自動決定
  $('#user_graduation_year').val(gyear);
  $('#user_department').val(department_text);
  $('#user_course').val(dcourse);
};

// ◎（田中追加）：隠しフィールドへの同期
function synchronize_hide_field() {
  // user_?_department_courseは、
  // user_?_courseにそのまま入るが、
  // user_?_departmentは、user_?_department_courseから推定して決める必要があることに注意
  if($('#user_is_tsukutech_' + gitan_name).prop('checked')){ 
    $('#user_c_department').val(gitan_department);
    $('#user_c_course').val($('#user_c_department_course option:selected').text()); // 未設定でも問題なし
  }

  if($('#user_is_tsukutech_' + gidai_name).prop('checked')){ 
    $('#user_u_department').val(gidai_department);
    $('#user_u_course').val($('#user_u_department_course option:selected').text()); // 未設定でも問題なし
  }

  if($('#user_is_tsukutech_' + gmaster_name).prop('checked')){
    $('#user_m_department').val(gmaster_department);
    $('#user_m_course').val($('#user_m_department_course option:selected').text()); // 未設定でも問題なし
  }
};

// ◎（田中追加）：sessionStorageへのバックアップ
function backup_session_storage(){
  if($('#user_is_tsukutech_' + gitan_name).prop('checked')){ 
    sessionStorage.user_c_department_course = $('#user_c_department_course option:selected').val(); // valueではなく、keyのほうで記憶
    sessionStorage.user_c_admission_year = $('#user_c_admission_year option:selected').val(); // valueではなく、keyのほうで記憶    
    sessionStorage.user_c_graduation_year = $('#user_c_graduation_year option:selected').val(); // valueではなく、keyのほうで記憶
  }

  if($('#user_is_tsukutech_' + gidai_name).prop('checked')){ 
    sessionStorage.user_u_department_course = $('#user_u_department_course option:selected').val(); // valueではなく、keyのほうで記憶
    sessionStorage.user_u_admission_year = $('#user_u_admission_year option:selected').val(); // valueではなく、keyのほうで記憶    
    sessionStorage.user_u_graduation_year = $('#user_u_graduation_year option:selected').val(); // valueではなく、keyのほうで記憶
  }

  if($('#user_is_tsukutech_' + gmaster_name).prop('checked')){
    sessionStorage.user_m_department_course = $('#user_m_department_course option:selected').val(); // valueではなく、keyのほうで記憶
    sessionStorage.user_m_admission_year = $('#user_m_admission_year option:selected').val(); // valueではなく、keyのほうで記憶    
    sessionStorage.user_m_graduation_year = $('#user_m_graduation_year option:selected').val(); // valueではなく、keyのほうで記憶
  }
}

// ◎（田中追加）：sessionStorageからのレストア(ただし、対象は引数から指定する)
function restore_session_storage(target_str){
  if( $('#' + target_str).has('option:selected').val() == "" 
  &&  sessionStorage.getItem(target_str) !== null){
    $('#' + target_str).val(sessionStorage.getItem(target_str));
  }
}


/*
// ◎（田中追加）：graduation_subjects.js.erbに定義されていた無名関数を、
// Q01～Q02-1-aによる分岐処理の変更の都合により、
// application.js内に移動させることになった。
function set_gyear_and_department_and_course() {

  // OBOG情報欄、ログイン情報欄、入力確認欄、ごめんなさいのところを一旦非表示にする。
  show_obog_register_customize(false);
  $('.login-register').hide();
  $('.actions').hide();
  $('.sorry').hide();
  
  // Q02-2も非表示にする（値もリセット）
  $('.q02-2').hide();
  $('input:radio[name="user[is_other_final]"]').prop('checked', false); // 他大学(大学院)が最終学歴かどうか

  // Q02-1-aの「卒業学科」で選択されているテキストを取得
  let department_course = $('#department_course option:selected').text();
  let g_value = $('#graduation_frame option:selected').val(); // Q02-1-aの「卒業学科」で選択されている実際のIDも同時に取得
  let u_value = $('#user_g_graduation_year option:selected').val(); // Q02-1-aの「卒業学科」で選択されている実際のIDも同時に取得
  let d_value = $('#department_course option:selected').val(); // Q02-1-aの「卒業学科」で選択されている実際のIDも同時に取得
 
  if (d_value != "" && u_value != '' && g_value != ''){
    // Q02-1-aの「卒業学科」「卒業年」「卒業時期」の各値が空でないとき  
    
    //「卒業時期」で指定された値を取得
    let graduation_frame_text = $('#graduation_frame option:selected').text();
    let department_text = '';

    // 「卒業時期」によって、出身学科の値を決める
    if(graduation_frame_text.includes('技短')) {
      department_text = gitan_department;   
    } else if(graduation_frame_text.includes('技大')) {
      department_text = gidai_department;
    } else if(graduation_frame_text.includes('大学院')) {
      department_text = gmaster_department;
    }

    $('#user_graduation_year').val($('#user_g_graduation_year option:selected').val()); // 卒業年の値を最終学歴の「卒業年」にも同様にセット（確定ではない）
    $('#user_department').val(department_text); // 出身学部の値を「卒業時期」で選択した値に合わせてセット
    $('#user_course').val(department_course); // 出身学科の値を「卒業学科」で選択した値をそのままセット

    // ここで隠しフィールドに、技大用の情報を設定する。
    $('#user_g_final_education').val($('#user_final_education').val());
    $('#user_g_department').val(department_text);
    $('#user_g_course').val(department_course);

    $('.q02-2').fadeIn('slow');
    $("html, body").animate({ scrollTop: $('.q02-2').offset().top },300);
  }
};
*/

// ◎（田中追加）：出身大学名と最終学歴を自動設定する関数。
// プログラム内で同じ処理を行うものが2箇所あるため、関数を作ることにした。
function set_school_and_final_education(graduation_frame)
{
  //  出身大学名と「卒業時期」の値を取得する
  let gitan = '技短';
  let grad_school = '大学院';
  let gidai = '技大';
  var edu_sch = '';

  //  出身大学名をQ01-2の「卒業時期」の値に合わせてセット
  if(graduation_frame.includes(gitan)) {
    edu_sch = '短大';
    $('#user_school').val(gitan_name);
  }else if(graduation_frame.includes(grad_school)) {
    edu_sch = '大学院（修士課程）';
    $('#user_school').val(gmaster_name);
  }else if(graduation_frame.includes(gidai)){
    edu_sch = '大学（学部）';
    $('#user_school').val(gidai_name);
  }else {
    edu_sch = '';
    $('#user_final_education').val('');
    $('#user_school').val('');
  }

  //  最終学歴の中から、「短大」または「大学院」または「大学（学部）」が含まれる値を探す
  //  注：eachはイベントではなく、要素一つずつに対する処理の繰り返し
  $('#user_final_education option').each(function() {
    if ($(this).val().includes(edu_sch) && edu_sch != '') {
      //  該当する値が見つかったら、その値を設定する。
      $('#user_final_education').val($(this).val());
    }
  });
}

// ◎（田中追加）：卒業時期等の設定を元に、回答項目の最終学歴等の設定を一括で行う。
// プログラム内で同じ処理を行うものが2箇所あるため、関数を作ることにした。
function set_graduation_subjects(id)
{
  //  下記を実行すると、viewフォルダ内の「graduation_subjects.js.erb」に
  //  記載されているコードの動きも含めて、以下が実行されるので、頭に入れておく。
  //  ・HTMLタグ【department_course_index（卒業学科）】に、
  //    DBに現存するすべての卒業学科を取得して、
  //  　【department_course_index（卒業学科）】にすべて格納する
  $.ajax({
    url: urlhead + "/users/graduation_subjects",
    type: "GET",
    data: { graduation_frame_id: id }
  }).done(function (data, textStatus, jaXHR) {
      var message = data.message;
      $('#user_u_department_course').children().remove();
      $('#user_u_department_course').append('<option value="">該当する学科・専攻を選んでください。</option>');
      for (var key in data) {
        $('#user_u_department_course').append('<option value="' + key + '">' + data[key] + '</option>');
      }
      //    }).fail(function() {
      if(sessionStorage.getItem('user_u_department_course') !== null){
        $('#user_u_department_course').val(sessionStorage.getItem('user_u_department_course'));
      }
  })
}

// ◎（田中追加）：OBOG情報欄の中で追加回答が出現するしないの再設定を行うための関数
function reset_add_query()
{
  let text;
  $('#add_industry').hide();
  $('#add_job').hide();

  text = $('#user_work_industry option:selected').text();
  if(text != "" && text.includes("その他")) {
    $('#add_industry').fadeIn("slow");
  }
  text = $('#user_work_job option:selected').text();
  if(text != "" && text.includes("その他")) {
    $('#add_job').fadeIn("slow");
  }
}

//  ◎（田中追加）：戻る処理を整理した関数
function back_process(){
  //  確認ページの表示を一度閉じ、再びOBOG情報欄・ログイン情報欄の
  //  入力ページの表示に戻す
  reg_cnf_change(false);
  //$("html, body").animate({ scrollTop: 0 },scrollTime);

  // どんな依頼でもOK!以外の各項目を非応答・半透明にしたり、応答可・非透明にする。
  $('input:checkbox[name="user[select_coops][]"]').each(function() {
    // ※直接idで指定したかったけど、idには日本語やエスケープ文字などが含まれている可能性があり、
    // 思い通りに指定できない可能性があるため、効率は悪いが以下のようにfor文で回してif文で一つ一つ確認してから、
    // 確実に処理を実施する形に変更した。
    if($(this).val() == gon.all_coop_purpose && $(this).prop('checked')){
      // 一度hideされた後はなぜか、チェックされていない状態になるみたいなので、
      // reg_form_show_toggleで、「どんな依頼でもOK!以外の各項目」の非応答・半透明化を
      // 一度処理はしているものの実行されていない様子。
      // そのため、戻るボタン押下時のみ以下の処理を追加。
    
      // どんな依頼でもOK!以外の各項目を非応答・半透明にしたり、応答可・非透明にする。
      change_visual_select_coops(true,0.5);

      return false; // breakの代わりに繰り返し処理を終了させる
    }
  });
}

// -------------関数（メソッド）記述はここまで--------------
// -------------ここから画面の動きに合わせたイベントの記述--------------

// ◎：画面の初期表示設定
let m_text = "1.個人情報の利用目的\n本学は、【登録フォーム】にて申請いただいた個人情報を、次の目的で利用することができるものとします。\n\n・聴覚障害者と聴覚障害者に関わる方々へのサポートのご協力を利用者の皆様に依頼するため。\n・メールマガジン等の配信、セミナーやイベントのご案内等のため。\n・利用者の皆様からのお問い合わせ等に対応するため。\n・利用者の皆様からお申し込みいただいたサービス等の提供のため。\n・当サイトが実施するアンケートへのご協力のお願いのため。\n・当サイトのサービス向上・改善、新サービスを検討するための分析等を行うため。\n・個人を識別できない形で統計データを作成し、当サイト及び利用者の皆様の参考資料とするため。\n\n2.個人情報の第三者への開示・提供の禁止\n本学は、利用者の皆様よりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。\n\n・利用者の皆様の同意がある場合\n・利用者の皆様が希望されるサービスを行なうために本学が業務を委託する業者に対して開示する場合\n・法令に基づき開示することが必要である場合\n\n3.個人情報の訂正・削除\n利用者の皆様がご自身の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応いたします。\nまた、【登録フォーム】にてご申請いただいた個人情報については、既に本登録が完了されている場合のみ、ご自身で個人情報の訂正又は削除を行うことができます。\n\n4．個人情報を提供されることの任意性\n利用者の皆様が本学に個人情報を提供されるかどうかは、利用者の皆様の任意によるものです。 \nただし、必要な項目を提供いただけない場合、各サービス等が適切な状態で提供できないことがあります。\n\n5．ご本人が容易に認識できない方法による個人情報の取得\n当サイトではCookies（クッキー）を使用しています。\nクッキーは、利用者の皆様が本学のサイトに再度訪問された際、より便利に当サイトを閲覧していただくためのものであり、利用者の皆様のプライバシーを侵害するものではなく、また利用者の皆様のコンピューターへ悪影響を及ぼすことはありません。\nクッキーは特定の個人を識別できるものではないため、個人情報には該当いたしません。\nまた、当サイトでは個人情報を入力していただく部分にはすべてSSL（Secure Sockets Layer）のデータ暗号化システムを利用しております。\nさらに、サイト内における情報の保護にもファイアウォールを設置するなどの方策を採っております。\nただし、インターネット通信の性格上、セキュリティを完全に保証するものではありません。\nあらかじめご了承ください。\n\n6.お問い合わせ先\n当サイトの個人情報の取扱に関するお問い合わせは下記までご連絡ください。\n\n日本財団奨学寄付金\n「聴覚障害者のためのキャリアサポートセンターの設置」事業 つくば拠点\nメールアドレス：　career_support[at]tsukutech-social.net　※[at]を@に変えてください。\nお問い合わせフォームから入力する場合はこちら　https://tsukutech-social.net/site/inquiry/\n※「聴覚障害者のためのキャリアサポートセンターの設置」事業は、筑波技術大学が日本財団からの助成を受け運営しております。";

$(window).on('load', function() {
  $('.q01').fadeIn('slow');
  $('#user_handling_of_personal_information').text(m_text);
});

// ◎：submit押下後render（描画）時対応
window.onpageshow = function() {
  reg_form_show_toggle();
};

var q01_number;
var q02_number;
var q02_0_number = 0;
var q02_1_number = 0;
var q02_2_number;
const scrollTime = 300;
var errorCheckInterval;

//　◎：Q01(メールマガジン入るかどうか)にて「はい」か「いいえ」のどちらかを押下したときのイベント
$(document).on('change', 'input:radio[name="user[is_mailmaga]"]', function() {

  //　エラー用装飾のクラスリセット
  //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
  //　（位置を特定できた場合、その位置まで自動スクロール可能）
  remove_error_class();
  
  //入力エラー文をリセット
  //　エラー文：エラーが発生したときに表示されるメッセージ
  remove_input_error_msg();

  //　OBOG情報欄・ログイン情報欄・入力確認・ごめんなさいのところは
  //　「はい」「いいえ」に関わらず、非表示にすることがわかっているので、
  // 　この時点で一括で非表示にする。
  show_gidai_register_customize(false);
  show_obog_register_customize(false);
  $('.login-register').hide();
  $('.actions').hide();
  $('.sorry').hide();

  //　応答・非応答のリセット
  disabled_login_register(true);
  disabled_gidai_register(true);
  disabled_obog_register(true);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  sessionStorage.clear();

  // メールマガジン登録への回答結果にかかわらず、必ず次の設問はQ02となるので、
  // 以下の通り処理する。
  $('.q02').fadeIn('slow');
  $('.q02-0').hide();
  $('.q02-1').hide();
  $('.q02-2').hide();
  $("html, body").animate({ scrollTop: $('.q02').offset().top },scrollTime);
});

//　◎：Q01（メールマガジン登録）にて「はい」か「いいえ」のどちらかをクリックしたときのイベント
//　※すでに「はい」を押したにも関わらず、「はい」をクリックするなど、
//　　前と同じものを選択するか、そうでない場合があるが、
// 　　それを想定したうえでの以下の実装と考えられる。
$(document).on('click',  'input:radio[name="user[is_mailmaga]"]',function() {
  if($(this).val() == q01_number) {
    // 以前と同じものを選択した場合は、
    // メールマガジンのところからやり直す感じで、設定した値をリセットしておく感じ。
    $(this).prop('checked', false);
    q01_number = 0;

    // 以下、すべて非表示
    $('.q02').hide();
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();
    show_gidai_register_customize(false);
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();
  } else {
    // 以前と異なるものを選択した場合は、
    // 改めてどちらを選択したか記憶しておく。
    q01_number = $(this).val();
  }

  //リセット
  $('input:radio[name="user[is_obog]"]').prop('checked', false); // OBOG協力可能かどうか
  $('input:checkbox[name="user[select_coops][]"]').prop('checked', false); // 協力目的
  $('input:checkbox[name="user[is_tsukutech][]"]').prop('checked', false); // // 技大出身の経験
  $('input:radio[name="user[is_other_final]"]').prop('checked', false); // 他大学(大学院)が最終学歴かどうか

  q02_0_number = 0;
  q02_1_number = 0;

  //　応答・非応答のリセット
  disabled_login_register(true);
  disabled_gidai_register(true);
  disabled_obog_register(true);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  sessionStorage.clear();

  // どんな依頼でもOK!以外の各項目を応答可・非透明に戻す。
  change_visual_select_coops(false, 1.0);
});


//　◎：Q02(協力依頼可能かどうか)にて「はい」か「いいえ」のどちらかを押下したときのイベント
$(document).on('change', 'input:radio[name="user[is_obog]"]', function() {

  //　エラー用装飾のクラスリセット
  //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
  //　（位置を特定できた場合、その位置まで自動スクロール可能）
  remove_error_class();

  //　入力エラー文をリセット
  //　エラー文：エラーが発生したときに表示されるメッセージ
  remove_input_error_msg();

  //　OBOG情報欄・ログイン情報欄・入力確認・ごめんなさいのところは
  //　「はい」「いいえ」に関わらず、非表示にすることがわかっているので、
  // 　この時点で一括で非表示にする。
  show_gidai_register_customize(false);
  show_obog_register_customize(false);
  $('.login-register').hide();
  $('.actions').hide();
  $('.sorry').hide();

  //　応答・非応答のリセット
  disabled_login_register(true);
  disabled_gidai_register(true);
  disabled_obog_register(true);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  sessionStorage.clear();

  if($(this).val() == 'true') {
    // OBOG協力「はい」の場合

    // Q02-0の質問を出現させ、q02-1～Q02-2の質問は隠す。
    $('.q02-0').fadeIn('slow');
    $('.q02-1').hide();
    $('.q02-2').hide();

    // Q02-1へスクロール移動
    $("html, body").animate({ scrollTop: $('.q02-0').offset().top },scrollTime);
  } else if( $(this).val() == 'false'){
    // OBOG協力「いいえ」の場合

    // Q02-0～02-2の質問を全て隠す。
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();

    // メールマガジン登録「はい」「いいえ」の分岐を確認してから、場合分けを行なう
    if ($('input:radio[name="user[is_mailmaga]"]:checked').val() == 'false'){  
      // メールマガジン登録いいえの場合
      // メールマガジン、OBOGどちらもNGということなので、
      // ごめんなさいのところを表示。

      $('.sorry').fadeIn('slow');
      $("html, body").animate({ scrollTop: $('.sorry').offset().top },scrollTime);

    } else if($('input:radio[name="user[is_mailmaga]"]:checked ').val() == 'true') {
      // メールマガジン登録「はい」の場合
      // ログイン情報欄と入力確認欄を表示させる。
      $('.login-register').fadeIn('slow');
      $('.actions').fadeIn('slow');
      $("html, body").animate({ scrollTop: $('.login-register').offset().top },scrollTime);

      // ログイン情報欄のみ入力可能とする。
      disabled_login_register(false);
    }
  }
});

//　◎：Q02にて「はい」か「いいえ」のどちらかをクリックしたときのイベント
//　※すでに「はい」を押したにも関わらず、「はい」をクリックするなど、
//　　前と同じものを選択するか、そうでない場合があるが、
// 　　それを想定したうえでの以下の実装と考えられる。
$(document).on('click',  'input:radio[name="user[is_obog]"]',function() {
  if($(this).val() == q02_number) {
    // 以前と同じものを選択した場合は、
    // 一旦、最初からやり直す感じで、設定した値をリセットしておく感じ。
    $(this).prop('checked',false); // Q 02でどちらも選択しない状態として表示を初期化
    q02_number = 0; // Q 02にて選択した値を初期化

    // 以下、すべて非表示
    $('.q02-0').hide();
    $('.q02-1').hide();
    $('.q02-2').hide();
    show_gidai_register_customize(false);
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();
  } else {
    // 以前と異なるものを選択した場合は、
    // 改めてどちらを選択したか記憶しておく。
    q02_number = $(this).val();
  }
  //リセット
  $('input:checkbox[name="user[select_coops][]"]').prop('checked', false); // 協力目的
  $('input:checkbox[name="user[is_tsukutech][]"]').prop('checked', false); // 技大出身の経験
  $('input:radio[name="user[is_other_final]"]').prop('checked', false); // 他大学(大学院)が最終学歴かどうか
  
  q02_0_number = 0;
  q02_1_number = 0;

  //　応答・非応答のリセット
  disabled_login_register(true);
  disabled_gidai_register(true);
  disabled_obog_register(true);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  sessionStorage.clear();

  // どんな依頼でもOK!以外の各項目を応答可・非透明に戻す。
  change_visual_select_coops(false,1.0);
});

//　◎：Q02-0（協力目的へのチェック）にていずれかの項目をチェックしたときのイベント
$(document).on('change', 'input:checkbox[name="user[select_coops][]"]', function() {

  if($(this).val() == gon.all_coop_purpose){
    // どんな依頼でもOK!に対してチェックした場合、
    // 他の項目をdisableにするかそうでないかを判定する。
    let flag = ($(this).prop('checked') == true); // チェック済なら他を非応答とし、チェックしないなら応答可能とする。
    let opa = ($(this).prop('checked') == true) ? 0.5 : 1.0;

    //  どんな依頼でもOK!以外の各項目を非応答・半透明にしたり、応答可・非透明にする。
    change_visual_select_coops(flag,opa);
  }

  if((q02_0_number == 0 && $('input:checkbox[name="user[select_coops][]"]:checked').length != 0)
  ||( q02_0_number != 0 && $('input:checkbox[name="user[select_coops][]"]:checked').length == 0))
  {
    //　エラー用装飾のクラスリセット
    //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
    //　（位置を特定できた場合、その位置まで自動スクロール可能）
    remove_error_class();

    //　入力エラー文をリセット
    //　エラー文：エラーが発生したときに表示されるメッセージ
    remove_input_error_msg();

    //　OBOG情報欄・ログイン情報欄・入力確認・ごめんなさいのところは
    //　「はい」「いいえ」に関わらず、非表示にすることがわかっているので、
    // 　この時点で一括で非表示にする。
    show_gidai_register_customize(false);
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();

    //　応答・非応答のリセット
    disabled_login_register(true);
    disabled_gidai_register(true);
    disabled_obog_register(true);

    // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
    sessionStorage.clear();

    if($('input:checkbox[name="user[select_coops][]"]:checked').length != 0)
    {
      // 協力目的のいずれか一つでも「チェック」した場合
  
      // Q02-1の質問を出現させ、Q02-1-a,2の質問は隠す。
      $('.q02-1').fadeIn('slow');
      $('.q02-2').hide();
  
      // Q02-1へスクロール移動
      $("html, body").animate({ scrollTop: $('.q02-1').offset().top },scrollTime);
    }
    else{
      // Q02-1～02-2の質問を隠す。
      $('.q02-1').hide();
      $('.q02-2').hide();
  
      $('input:checkbox[name="user[is_tsukutech][]"]').prop('checked', false); // 技大出身の経験
      $('input:radio[name="user[is_other_final]"]').prop('checked', false); // 他大学(大学院)が最終学歴かどうか
    
      // Q02-0へスクロール移動
      $("html, body").animate({ scrollTop: $('.q02-0').offset().top },scrollTime);
    }
  }

  // 最後にチェックした総数を記憶する。
  q02_0_number = $('input:checkbox[name="user[select_coops][]"]:checked').length;
});

//　◎：Q02-1（技短・技大・大学院出身経験ありかそうでないかのチェック）にていずれかの項目をチェックしたときのイベント
$(document).on('click', 'input:checkbox[name="user[is_tsukutech][]"]', function() {
  // いずれも経験なしにチェックした場合はそのほかの全てのチェックボックスからチェックを外し、
  // それ以外にチェックした場合は、いずれも経験なしからチェックを外す
  if($(this).val() == other_name){
    $('input:checkbox[name="user[is_tsukutech][]"]').each(function() {
      if($(this).val() != other_name){
        $(this).prop('checked', false);
      }
    });
  }else{
    $('#user_is_tsukutech_' + other_name).prop('checked', false);
  }

  //　エラー用装飾のクラスリセット
  //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
  //　（位置を特定できた場合、その位置まで自動スクロール可能）
  remove_error_class();

  //　入力エラー文をリセット
  //　エラー文：エラーが発生したときに表示されるメッセージ
  remove_input_error_msg();

  //　OBOG情報欄・ログイン情報欄・入力確認・ごめんなさいのところは
  //　「はい」「いいえ」に関わらず、非表示にすることがわかっているので、
  // 　この時点で一括で非表示にする。
  show_gidai_register_customize(false);
  show_obog_register_customize(false);
  $('.login-register').hide();
  $('.actions').hide();
  $('.sorry').hide();

  //　応答・非応答のリセット
  disabled_login_register(true);
  disabled_gidai_register(true);
  disabled_obog_register(true);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  //sessionStorage.clear(); //技大関連出身に関する経験への回答が変わるたびに初期化する必要なし

  if ($('input:checkbox[name="user[is_tsukutech][]"]:checked').length != 0) {
    if ($(this).val() != other_name) {
      // 技大・技短・技大大学院卒の場合はq02-2を表示（スクロールも実施）
      // 最終質問の、q02-2と繋げる。
      $('.q02-2').fadeIn('slow');
      $("html, body").animate({ scrollTop: $('.q02-2').offset().top }, scrollTime);

      let if_text = 'input:radio[name="user[is_other_final]"]:checked';
      // 筑波出身経験のチェック総数が1以上(チェック済）かつ、最終学歴に関する質問が回答済の場合のみ、以下実行
      if(q02_1_number > 0 && ($(if_text).val() == 'true' || $(if_text).val() == 'false')){
        show_gidai_register_customize(true);
        show_obog_register_customize(true);
        $('.login-register').show();
        $('.actions').show();

        //　応答・非応答のリセット
        disabled_login_register(false);
        disabled_gidai_register(false);
        disabled_obog_register(false);

        if($(if_text).val() == 'false') {
          // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
          set_final_education_informations();
        }
        synchronize_hide_field(); // 隠しフィールドの同期
        backup_session_storage(); // sessionStorageへバックアップ

        //必要に応じて必須から任意に変更
        change_faculty_optional();
        gc_faculty_optional();
      }
      else{
        // Q2-2の回答もリセット
        $('input:radio[name="user[is_other_final]"]').prop('checked', false);
      }
    }
    else {
      // 技大・技短・技大大学院卒以外の場合はq02-2の表示＆技大関連情報の入力不要
      $('.q02-2').hide();

      // Q2-2の回答もリセット
      $('input:radio[name="user[is_other_final]"]').prop('checked', false);

      // 「技大かどうか」の質問に答えている時点で、
      //  OBOG情報欄・ログイン情報欄・入力確認欄の表示は確定しているので、
      //  「OBOG登録協力」「メールマガジン登録」による場合分け不要
      show_obog_register_customize(true);
      $('.login-register').fadeIn('slow');
      $('.actions').fadeIn('slow');
      $("html, body").animate({ scrollTop: $('.obog-register').offset().top }, scrollTime);

      //　入力項目はOBOG情報欄、ログイン情報欄共に表示とする。
      disabled_obog_register(false);
      disabled_login_register(false);

      //必要に応じて必須から任意に変更
      change_faculty_optional();
    }
  }
  else {
    // Q02-1の質問を出現させ、Q02-2の質問は隠す。
    $('.q02-2').hide();

    // Q02-1へスクロール移動
    $("html, body").animate({ scrollTop: $('.q02-1').offset().top }, scrollTime);
  }

  // 最後にチェックした総数を記憶する。
  q02_1_number = $('input:checkbox[name="user[is_tsukutech][]"]:checked').length;
});

/*
//　◎：Q02-1（技大出身かどうか）にて「はい」か「いいえ」のどちらかを押下したときのイベント
$(document).on('change', 'input:radio[name="user[is_gidai]"]', function() {

    //　エラー用装飾のクラスリセット
    //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
    //　（位置を特定できた場合、その位置まで自動スクロール可能）
    remove_error_class();

    //　入力エラー文をリセット
    //　エラー文：エラーが発生したときに表示されるメッセージ
    remove_input_error_msg();

    //　OBOG情報欄・ログイン情報欄・入力確認・ごめんなさいのところは
    //　「はい」「いいえ」に関わらず、非表示にすることがわかっているので、
    // 　この時点で一括で非表示にする。
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();

    if($(this).val() == 'true') {
      // 技大・技短・技大大学院卒の場合はq02-1-aを表示（スクロールも実施）
      // q02-2はまだ隠す
      $('.q02-1-a').fadeIn('slow');
      $('.q02-2').hide();
      reset_gidai();  //  卒業学科など、技大に関連する値のリセット
      $("html, body").animate({ scrollTop: $('#q02-1-a').offset().top },scrollTime);
    } else if( $(this).val() == 'false'){
      // 技大・技短・技大大学院卒の場合はq02-1-a,2の表示不要
      $('.q02-1-a').hide();
      $('.q02-2').hide();
      reset_gidai();  //  卒業学科など、技大に関連する値のリセット

      // 「技大かどうか」の質問に答えている時点で、
      //  OBOG情報欄・ログイン情報欄・入力確認欄の表示は確定しているので、
      //  「OBOG登録協力」「メールマガジン登録」による場合分け不要
      show_obog_register_customize(true);
      $('.login-register').fadeIn('slow');
      $('.actions').fadeIn('slow');
      $("html, body").animate({ scrollTop: $('.obog-register').offset().top },scrollTime);

      //　入力項目はOBOG情報欄、ログイン情報欄共に表示とする。
      disabled_obog_register(false);
      disabled_login_register(false);

      //必要に応じて必須から任意に変更
      change_faculty_optional();
    } 
});

//　◎：Q02-1にて「はい」か「いいえ」のどちらかをクリックしたときのイベント
//　※すでに「はい」を押したにも関わらず、「はい」をクリックするなど、
//　　前と同じものを選択するか、そうでない場合があるが、
// 　　それを想定したうえでの以下の実装と考えられる。
$(document).on('click',  'input:radio[name="user[is_gidai]"]',function() {
  if($(this).val() == q02_1_number) {
    // 以前と同じものを選択した場合は、
    // Q02-1からやり直す感じで、設定した値をリセットしておく感じ。
    $(this).prop('checked', false); // Q 02-1でどちらも選択しない状態として表示を初期化
    q02_1_number = 0; // Q 02-1にて選択した値を初期化

    // 以下、すべて非表示 
    $('.q02-1-a').hide();
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();
  } else {
    // 以前と異なるものを選択した場合は、
    // 改めてどちらを選択したか記憶しておく。
    q02_1_number = $(this).val();
  }

  //リセット
  $('input:radio[name="user[is_other_final]"]').prop('checked', false); // 他大学(大学院)が最終学歴かどうか
  $('#graduation_frame').val(''); // 卒業時期

  // 隠しフィールドの値もリセット
  $('#user_g_final_education').val('');
  $('#user_g_department').val('');
  $('#user_g_course').val('');
});
*/

//　◎：Q02-2（最終学歴が他大学かどうか）にて「はい」か「いいえ」のどちらかを押下したときのイベント
$(document).on('change', 'input:radio[name="user[is_other_final]"]', function() {

  //　エラー用装飾のクラスリセット
  //　このクラスは、エラー発生時に、エラーがある項目の位置を特定するために使用する。
  //　（位置を特定できた場合、その位置まで自動スクロール可能）
  remove_error_class();

  //　入力エラー文をリセット
  //　エラー文：エラーが発生したときに表示されるメッセージ
  remove_input_error_msg();

  if($(this).val() == 'false'){
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();

    synchronize_hide_field(); // 隠しフィールドの同期
    backup_session_storage(); // sessionStorageへバックアップ
  }
  else if($(this).val() == 'true'){
    //  他大学(大学院)が最終学歴の場合、最終学歴の入力欄を表示＆入力内容をクリアする必要がある。
    $('#user_graduation_year').val('');
    $('#user_department').val('');
    $('#user_course').val('');
    $('#user_final_education').val('');
    $('#user_school').val('');
  } 

  // すべての回答が出揃ったので、各入力項目を出現させ、スクロールする。
  show_gidai_register_customize(true);
  show_obog_register_customize(true);
  $('.login-register').fadeIn('slow');
  $('.actions').fadeIn('slow');
  $("html, body").animate({ scrollTop: $('.gidai-register').offset().top },scrollTime);
  
  //　各種情報入力欄を入力可能とする。
  disabled_gidai_register(false);
  disabled_obog_register(false);
  disabled_login_register(false);

  // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
  //sessionStorage.clear(); //is_other_finalの設問に対する回答を切り替えるたびに初期化する必要なし
  
  //必要に応じて必須から任意に変更
  change_faculty_optional();
  gc_faculty_optional();
});

//　◎：Q02-2にて「はい」か「いいえ」のどちらかをクリックしたときのイベント
//　※すでに「はい」を押したにも関わらず、「はい」をクリックするなど、
//　　前と同じものを選択するか、そうでない場合があるが、
// 　　それを想定したうえでの以下の実装と考えられる。
$(document).on('click',  'input:radio[name="user[is_other_final]"]',function() {
  if($(this).val() == q02_2_number) {
    // 以前と同じものを選択した場合は、
    // Q02-2からやり直す感じで、設定した値をリセットしておく感じ。
    $(this).prop('checked', false); // Q 02-2でどちらも選択しない状態として表示を初期化
    q02_2_number = 0; // Q 02-2にて選択した値を初期化

    // 以下、すべて非表示
    show_gidai_register_customize(false);
    show_obog_register_customize(false);
    $('.login-register').hide();
    $('.actions').hide();
    $('.sorry').hide();

    //　OBOG情報欄、ログイン情報欄共に一旦、入力不可とする。
    disabled_gidai_register(true);
    disabled_obog_register(true);
    disabled_login_register(true);

    // sessionStorageの完全初期化（実際には、技大の卒業学科・専攻の値のみだが）
    //sessionStorage.clear(); //is_other_finalの設問に対する回答を切り替えるたびに初期化する必要なし
  } else {
    // 以前と異なるものを選択した場合は、
    // 改めてどちらを選択したか記憶しておく。
    q02_2_number = $(this).val();
  }
});

// ◎：技短の入学年を変更したときのイベント 
$(document).on('change', 'select[name="user[c_admission_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技短の卒業年を変更したときのイベント 
$(document).on('change', 'select[name="user[c_graduation_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技短の卒業学科を変更したときのイベント 
$(document).on('change', 'select[name="user[c_department_course]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大の入学年を変更したときのイベント 
$(document).on('change', 'select[name="user[u_admission_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大の卒業年を変更したときのイベント 
$(document).on('change', 'select[name="user[u_graduation_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大の卒業学科を変更したときのイベント 
$(document).on('change', 'select[name="user[u_department_course]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大大学院の入学年を変更したときのイベント 
$(document).on('change', 'select[name="user[m_admission_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大大学院の卒業年を変更したときのイベント 
$(document).on('change', 'select[name="user[m_graduation_year]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

// ◎：技大大学院の卒業学科を変更したときのイベント 
$(document).on('change', 'select[name="user[m_department_course]"]', function() {
  if($('input:radio[name="user[is_other_final]"]:checked').val() == 'false') {
    // 「いいえ」と回答した場合のみ、最終学歴関連情報を自動設定
    set_final_education_informations();
  }
  synchronize_hide_field(); // 隠しフィールドの同期
  backup_session_storage(); // sessionStorageへバックアップ
});

//  ◎：OBOG情報欄の最終学歴について、値が変更されたとき
$(document).on('change',  'select[name="user[final_education]"]',function() {
  //  例えば、技大関係者以外の方の最終学歴が大学・大学院であった場合、
  //  出身学部への回答が必須になり、そうでないときは必須にならない。
  change_faculty_optional();
});

//  ◎：OBOG情報欄の学校名について、そのフォーカスを失ったとき
$(document).on('blur', 'input:text[name="user[school]"]', function(){
  //  以下の出身学部・学科への必須項目の割り当ては、
  //  大学名が技大かもしくは技大以外か切り替わった場合を想定？
  change_faculty_optional();
});

// ◎：OBOG情報欄の【現在の就労状態】に対して値を変更した時のイベント 
//$(document).on('change', 'select[name="user[work_status]"]', function() {
$(document).on('change', 'input:radio[name="user[work_status]"]:checked', function() {
  //  現在の就労状態によって、会社名・勤務先・配属先への必須回答が変わる
  change_faculty_optional();
});

//  ◎：参考＞「turbolinks:load」イベントは初回のページ表示時やTurbolinksによりページの状態が遷移した際に発火するイベント
// https://qiita.com/zenfumi/items/a92c0385d361e04fb014
$(document).on('turbolinks:load', function() {

  //  ◎：Q02-1-aのところで、「卒業時期」などの値が変更したときのイベントを
  //  ここ（「turbolinks:load」イベント内）で定義している。
  //  この関数は、viewフォルダ内の「graduation_subjects.js.erb」のコードも含めて
  //  一緒に動きを追わないと、意図を理解しづらいので気を付けること。
  $('#user_u_graduation_frame').on("change", function() {
    set_graduation_subjects($('#user_u_graduation_frame').has('option:selected').val());
    // メールアドレスが既に存在した場合等、卒業時期等がリセットされてしまった場合のバックアップ方法
    sessionStorage.user_u_graduation_frame = $('#user_u_graduation_frame option:selected').val();
  });
});

//  ◎：氏名かな、旧姓かな（日本語の自動かな入力）
$(document).ready(function() {
  $.fn.autoKana('#user_name','#user_kana' );
  $.fn.autoKana('#user_maiden_name', '#user_maiden_kana');

  //卒業学科・専攻の選択肢設定
  //set_graduation_subjects(id)
});

//  ◎：入力確認ボタンをクリックしたときのイベント
$(document).on('click', '#check', function() {

    //  各入力項目のエラーチェックを行なう
    if(!reg_input_check()) { 
      //  エラーが見つかった場合
      if($('.reg_error').length) {
        // reg_errorが付いている項目が見つかった場合は、その項目まで自動スクロール
        $("html, body").animate({ scrollTop: $('.reg_error').first().offset().top },scrollTime);
      }else {
        // reg_errorが付いている項目がない場合、OBOG情報欄の先頭もしくはログイン情報欄の先頭まで自動スクロール
        // どの位置に移動するかは、OBOG情報欄の名前入力のところが非表示になっているかどうかで決まる
        if(!$('select[name="user[c_admission_year]"').is(':disabled')
        || !$('select[name="user[u_admission_year]"').is(':disabled')
        || !$('select[name="user[m_admission_year]"').is(':disabled')){
          $("html, body").animate({ scrollTop: $('.gidai-register').offset().top },scrollTime);
        }
        else if(!$('input[name="user[name]"').is(':disabled')){
          $("html, body").animate({ scrollTop: $('.obog-register').offset().top },scrollTime);
        }
        else{
          $("html, body").animate({ scrollTop: $('.login-register').offset().top },scrollTime);
        }
      }
      return false; 
    }

    // 念のため、最後にもう一度同期をとる。
    synchronize_hide_field(); // 隠しフィールドの同期

    //  確認ページにて、OBOG情報欄・ログイン情報欄を表示させる
    //  ※登録者の入力状態によって表示が変わるので、 
    //  必ずしも、両方の情報欄がいつも表示されるとは限らない
    reg_cnf_change();

    //  入力した値を一括で取得
    $("html, body").animate({ scrollTop: 0 },scrollTime);
    let select_coops = $('input:checkbox[name="user[select_coops][]"]:checked').map(function() { return $(this).val();}).get().join(",");
    if(select_coops.indexOf(gon.all_coop_purpose) >= 0) select_coops = gon.all_coop_purpose;

    // 入力内容セット
    const c_admission_year = $('#user_c_admission_year option:selected').text() != " ---- " ? $('#user_c_admission_year option:selected').text() : "";
    const u_admission_year = $('#user_u_admission_year option:selected').text() != " ---- " ? $('#user_u_admission_year option:selected').text() : "";
    const m_admission_year = $('#user_m_admission_year option:selected').text() != " ---- " ? $('#user_m_admission_year option:selected').text() : "";
    const c_graduation_year = $('#user_c_graduation_year option:selected').text() != " ---- " ? $('#user_c_graduation_year option:selected').text() : "";
    const u_graduation_year = $('#user_u_graduation_year option:selected').text() != " ---- " ? $('#user_u_graduation_year option:selected').text() : "";
    const m_graduation_year = $('#user_m_graduation_year option:selected').text() != " ---- " ? $('#user_m_graduation_year option:selected').text() : "";
    const c_department_course = $('#user_c_department_course option:selected').text();
    const u_department_course = $('#user_u_department_course option:selected').text();
    const m_department_course = $('#user_m_department_course option:selected').text();
    //const u_graduation_frame = $('#user_u_graduation_frame option:selected').text();

    const name = $('#user_name').val();
    const kana = $('#user_kana').val();
    const maiden_name = $('#user_maiden_name').val();
    const maiden_kana = $('#user_maiden_kana').val();
    const graduation_year = $('#user_graduation_year option:selected').text();
    const final_education = $('#user_final_education option:selected').text();
    const school = $('#user_school').val();
    const department = $('#user_department').val();
    const course = $('#user_course').val();
    const company = $('#user_company').val();
    const work_place = $('#user_work_place option:selected').text();
    const assienment = $('#user_assienment').val();
    const communication = $('input:checkbox[name="user[communication][]"]:checked').map(function() { return $(this).val();}).get().join(",");
    const tel = $('#user_tel').val();
    const fax = $('#user_fax').val();
    const comment = $('#user_comment').val();
    const query = $('#user_query').val();
    const email = $('#user_email').val();

    var text;
    //const work_status = $('#user_work_status option:selected').text();
    text = $('[for="user_work_status_' + $('input:radio[name="user[work_status]"]:checked').val() + '"').text();
    const work_status = text;
    text = $('#user_work_industry option:selected').text();
    const work_industry = ((text != "" && text.includes("その他")) ? ('その他：' + $('#user_other_industry').val()) : text);
    text = $('#user_work_job option:selected').text();
    const work_job = ((text != "" && text.includes("その他")) ? ('その他：' + $('#user_other_job').val()) : text);
    const work_description = $('#user_work_description').val();

    //  パスワードは入力した値の長さに合わせて、"*"のみ並べた文字列を出しておく
    var cnf_password = '';
    for(var num = 0; num < $('#user_password').val().length; num++){
      cnf_password += '*';
    }
  
    //  入力した値を確認ページへ表示させる
    //　技大関連情報欄
    $('#cnf_c_admission_year').text(c_admission_year);
    $('#cnf_c_graduation_year').text(c_graduation_year);
    $('#cnf_c_department_course').text(c_department_course);
    $('#cnf_u_admission_year').text(u_admission_year);
    $('#cnf_u_graduation_year').text(u_graduation_year);
    $('#cnf_u_department_course').text(u_department_course);
    $('#cnf_m_admission_year').text(m_admission_year);
    $('#cnf_m_graduation_year').text(m_graduation_year);
    $('#cnf_m_department_course').text(m_department_course);

    //  OBOG情報欄
    $('#cnf_select_coops').text(select_coops);
    $('#cnf_name').text(name);
    $('#cnf_kana').text(kana);
    $('#cnf_maiden_name').text(maiden_name);
    $('#cnf_maiden_kana').text(maiden_kana);
    $('#cnf_graduation_year').text(graduation_year);
    $('#cnf_final_education').text(final_education);
    $('#cnf_school').text(school);
    $('#cnf_department').text(department);
    $('#cnf_course').text(course);
    $('#cnf_work_status').text(work_status);
    $('#cnf_company').text(company);
    $('#cnf_work_place').text(work_place);
    $('#cnf_assienment').text(assienment);
    $('#cnf_work_industry').text(work_industry);
    $('#cnf_work_job').text(work_job);
    $('#cnf_work_description').text(work_description);
    $('#cnf_communication').text(communication);
    $('#cnf_tel').text(tel);
    $('#cnf_fax').text(fax);
    $('#cnf_comment').text(comment);
    $('#cnf_query').text(query);
  
    //  ログイン情報欄
    $('#cnf_email').text(email);
    $('#cnf_password').text(cnf_password);
    $('#cnf_password_confirmation').text(cnf_password);
    
});

//  ◎：（確認ページの）戻るボタンをクリックしたときのイベント
$(document).on('click', '#back', function() 
{
  back_process(); // 戻る処理の実装
  $("html, body").animate({ scrollTop: 0 },scrollTime); // 最上部までスクロール
});

//  ◎：OBOG情報欄・ログイン情報欄の各入力項目(input)に対してフォーカスを失った時のイベント 
//    　必須項目に対して何も入力されていなかったときにエラーメッセージを表示
$(document).on('blur', 'input.req', function() {
  if($(this).val() == "") {
    $(this).siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
  } else {
    $(this).siblings('span.error_reauired').text("");
  }
});

//  ◎：OBOG情報欄・ログイン情報欄の各入力項目(select))に対して値を変更した時のイベント 
//    　必須項目に対して何も選択されていない（"---"を選択した）ときにエラーメッセージを表示
$(document).on('change','select.req', function() {
  if($(this).has('option:selected').val() == "") {
    $(this).parents('.tbl_c').children('span.error_reauired').text("選択してください").css('color', 'red');
  } else {
    $(this).parents('.tbl_c').children('span.error_reauired').text("");
  }
});

//  ◎：(田中追記：ほぼラジオボタン専用（classタグのselect_yesno専用）になっているが)
//　　　OBOG情報欄・ログイン情報欄の各入力項目(input)に対して値を変更した時のイベント 
//    　ラジオボタンに対して何かしら値が変更されていれば、エラーメッセージの表示を無くすことができる。
$(document).on('change','input.req', function() {
  if($(this).val() == "") {
    $(this).parents().siblings('span.error_reauired').text("入力必須項目です").css('color', 'red');
  } else {
    $(this).parents().siblings('span.error_reauired').text("");
  }
});

//  ◎：OBOG情報欄の【氏名かな】、【旧姓かな】に対してフォーカスを失った時のイベント 
//    　かなが全角ひらがなになっていないときにエラーメッセージを表示
$(document).on('blur','#user_kana, #user_maiden_kana', function() {
  const result = $(this).val().match(/^[ぁ-んー　]*$/);
  if(!result && $(this).val() != "") {
    $(this).siblings('span.error_msg').text('全角ひらがなで入力してください').css('color','red');
  } else {
    $(this).siblings('span.error_msg').text('');
  }
});

// ◎：OBOG情報欄の【可能なコミュニケーション手段（複数回答可）】に対して値を変更した時のイベント 
//    一つもチェックしていないときにエラーメッセージを表示
$(document).on('change', 'input:checkbox[name="user[communication][]"]', function() {
  if( $('input:checkbox[name="user[communication][]"]:checked').length > 0) {
    $('input:checkbox[name="user[communication][]"]').parents('.tbl_c').children('span.error_reauired').text("");
  } else {
    $('input:checkbox[name="user[communication][]"]').parents('.tbl_c').children('span.error_reauired').text("いずれか1つ以上、選択してください").css('color', 'red');
  }
});

// ◎：OBOG情報欄の【電話番号】に対してフォーカスを失った時のイベント 
//    電話番号なのに数字以外、もしくは10・11桁以外の数字を入力した場合にエラーメッセージを表示
$(document).on('blur', '#user_tel, #user_fax', function(){
  const result = $(this).val().match(/^(\d{10,11})$/);
 
  if((!result) && $(this).val() != "") {
    $(this).siblings('span.error_msg').text('正しい電話番号を入力してください').css('color','red');
  } else {
    $(this).siblings('span.error_msg').text('');
  }
});

// ◎：OBOG情報欄の【メールアドレス】に対してフォーカスを失った時のイベント 
//    不適切なメールアドレスを入力した場合にエラーメッセージを表示
$(document).on('blur', '#user_email', function() {
  if($(this).val() != "" && !$(this).val().match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/)) {
    $(this).siblings('span.error_reauired').text('正しい形式で入力してください。').css('color', 'red');
  } else {
    $(this).siblings('span.error_reauired').text("");
  }
});

// ◎：OBOG情報欄の【パスワード】、【確認パスワード】に対してフォーカスを失った時、またはキーを押して離した時のイベント 
//    パスワードと確認パスワードの値が一致しない、もしくはパスワードが入力されていない場合にエラーメッセージを表示
$(document).on('keyup blur', '#user_password, #user_password_confirmation', function() {
  if($('#user_password').val() != $('#user_password_confirmation').val() && $('#user_password_confirmation').val().length > 0) {
    $(this).siblings('span#pass_msg').html('パスワードが一致しません<br>').css('color', 'red');
  } else {
    $(this).siblings('span#pass_msg').text("");
  }
});

// ◎：OBOG情報欄の【パスワード】、【確認パスワード】、【現在のパスワード】に対してフォーカスを失った時のイベント 
//    パスワードが一定数文字以上入力されていない場合にエラー表示
$(document).on('blur', '#user_password, #user_password_confirmation', function() {
  const pass_minlength = $('em#password_length_msg').attr('minlength');
  if($(this).val().length < pass_minlength && $(this).val().length > 0) {
    $(this).siblings('span.error_length').html(pass_minlength+'文字以上で入力してください<br>').css('color','red');
  } else {
    $(this).siblings('span.error_length').text('');
  }
});

// ◎：OBOG情報欄の【業種】に対して値を変更した時のイベント 
$(document).on('change', 'select[name="user[work_industry]"]', function() {
  var text = $('#user_work_industry option:selected').text();
  if(text != "" && text.includes("その他")) {
    $('#add_industry').fadeIn("slow");
  } else {
    $('#add_industry').fadeOut("slow");
  }
});

// ◎：OBOG情報欄の【職種】に対して値を変更した時のイベント 
$(document).on('change', 'select[name="user[work_job]"]', function() {
  var text = $('#user_work_job option:selected').text();
  if(text != "" && text.includes("その他")) {
    $('#add_job').fadeIn("slow");
  } else {
    $('#add_job').fadeOut("slow");
  }
});

// ◎：注意事項に同意する時のチェックボックスの状態を変えたときのイベント
// ちなみにid="user_agreement_agreement"は、"user_agreement"ではなく、実際にそうなった。
$(document).on('change', 'input:checkbox[id="user_agreement_agreement"]', function() {
  let flag = $(this).prop('checked');
  if(flag){
    //  送信ボタン有効
    $('#btn-send').prop("disabled", false);
  }
  else{
    //  送信ボタン無効
    $('#btn-send').prop("disabled", true);
  }
});

$(document).on('change', 'input:checkbox[name="user[show_password][]"]', function() {
  let type_str = "password";
  if($('input:checkbox[id="user_show_password_yes"]').prop("checked")){
      type_str = 'text';
  }
  $('#user_password').get(0).type = type_str;
});

$(document).on('change', 'input:checkbox[name="user[show_password_confirmation][]"]', function() {
  let type_str = "password";
  if($('input:checkbox[id="user_show_password_confirmation_yes"]').prop("checked")){
      type_str = 'text';
  }
  $('#user_password_confirmation').get(0).type = type_str;
});

// ◎：更新するボタンを押下したときのイベント
$(function() {
  $("form").submit(function(e) {
    errorCheckInterval = setInterval(function (){
      $.ajax({
        url: urlhead + "/users/get_messages",
        type: "GET",
        data: { email: $('#user_email').val() }
      }).done(function (data, textStatus, jaXHR) {
          let s_message = data.s_message;
          let m_message = data.m_message;

          if(s_message !== null){
            clearInterval(errorCheckInterval); // エラー原因がわかったので、インターバル終了
            back_process(); // 戻る処理の実装

            let temp = m_message.split(":")
            let code = temp[0];
            let show = temp[1];

            switch(code){
              case "101":
                // 存在しないメールアドレスを指定したかもしれない。
                $('#user_email').siblings('span.error_reauired').text(show).css('color', 'red');
                $('#user_email').addClass("reg_error");
                $("html, body").animate({ scrollTop: $('.reg_error').first().offset().top },scrollTime);
                //$('#yobi').html('<div id="yobi_error_explanation"><ul><li>' + show + '<br>' + s_message + '<br>大変恐れ入りますが、可能であれば、現在表示中の画面のスクリーンショットを獲り、以下のメールアドレスへ添付してご連絡ください。<br>career_support[at]tsukutech-social.net　※[at]を@に変えてください。</li></ul></div>');
                break;
              default:
                // 予期しないエラーが発生した
                $('#yobi').html('<div id="yobi_error_explanation"><ul><li>' + show + '<br>' + s_message + '<br>大変恐れ入りますが、可能であれば、現在表示中の画面のスクリーンショットを獲り、以下のメールアドレスへ添付してご連絡ください。<br>career_support[at]tsukutech-social.net　※[at]を@に変えてください。</li></ul></div>');
                $("html, body").animate({ scrollTop: 0 },scrollTime); // 最上部までスクロール
                break;
            }
          }
      })
    }, 1000);
  });
});